import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountComponent, MyFavoritesComponent, AccountInformationComponent, InvoicesComponent } from './';
import { UpdateCardComponent } from './update-card/update-card.component';
import { UpdatePlanComponent } from './update-plan/update-plan.component';
import { ProfileComponent } from './profile/profile.component';
import { EmailDeliveryComponent, EmailScheduleComponent, EmailSettingsComponent } from './email-delivery';

import { AppContext, LogService, AuthService, ApiService, UserService, FavoriteService, BillingService } from './../shared';

import { SharedModule } from './../shared/shared.module';
import { AccountRoutingModule } from './account-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, AccountRoutingModule],
  declarations: [AccountComponent, MyFavoritesComponent, AccountInformationComponent, InvoicesComponent, UpdateCardComponent, UpdatePlanComponent, ProfileComponent, EmailDeliveryComponent, EmailScheduleComponent, EmailSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AppContext, LogService, AuthService, ApiService, UserService, FavoriteService, BillingService]
})

export class AccountModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/account.module.ts